import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';

const AddressList = () => {
  const [addresses, setAddresses] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const returnTo = location.state?.returnTo;

  const product = location.state?.product;
  const cartIds = location.state?.cartIds || [];
  const selectedCouponId = location.state?.selectedCouponId;

  // 1. 배송지 목록 로드 (Flask의 address() 뷰 역할)
  const fetchAddresses = async () => {
    try {
      const res = await axios.get('/api/address');
      // res.data.addresses 가 Flask에서 넘겨주던 addresses 변수와 동일함
      setAddresses(res.data.addresses || []);
    } catch (err) {
      console.error("배송지 목록 로드 실패", err);
    }
  };

  useEffect(() => {
    fetchAddresses();
  }, []);

  // 2. 기본 배송지 설정 (Flask의 address_set_default 역할)
  const handleSetDefault = async (id) => {
    try {
      await axios.get(`/api/address/set-default?id=${id}`);
      fetchAddresses(); // 목록 새로고침
    } catch (err) {
      alert("기본 배송지 설정에 실패했습니다.");
    }
  };

  // 3. 배송지 삭제 (Flask의 address_delete 역할)
  const handleDelete = async (id) => {
    if (window.confirm('삭제하시겠습니까?')) {
      try {
        await axios.get(`/api/address/delete?id=${id}`);
        fetchAddresses(); // 목록 새로고침
      } catch (err) {
        alert("배송지 삭제에 실패했습니다.");
      }
    }
  };

  const handleSelectAddress = (addr) => {
    if (!returnTo) return;
  
    navigate(returnTo, {
      state: {
        product,
        cartIds,
        selectedAddress: addr,
        orderType: 'delivery',
        selectedCouponId
      }
    });
  };

  const handleCancel = () => {
    if (returnTo) {
      navigate(returnTo, {
        state: {
          product,
          cartIds,
          selectedCouponId
        }
      });
    } else {
      navigate(-1);
    }
  };

  return (
    <div className="container mt-3" style={styles.container}>
      <h3 className="mb-3" style={styles.title}>배송지 관리</h3>

      <div className="mb-2">
        {/* Flask: url_for('address.address_add') */}
        <button 
          className="btn btn-primary" 
          onClick={() =>
            navigate('/address/add', {
              state: {
                returnTo,
                product,
                cartIds,
                selectedCouponId
              }
            })
          }
          style={styles.addBtn}
        >
          + 배송지 추가
        </button>
      </div>

      {/* Flask: {% for addr in addresses %} */}
      {addresses.map((addr) => (
        <div key={addr.id} className="address-card" style={styles.addressCard}>
          <div className="address-header d-flex justify-content-between align-items-center" style={styles.addressHeader}>
            <div>
              <strong>{addr.receiver_name}</strong> 
              <span className="address-date" style={styles.addressDate}> ({addr.receiver_phone})</span>
            </div>
            <div className="address-actions text-end">
              {/* Flask: url_for('address.address_edit', id=addr.id) */}
              <span
                style={styles.addressActionLink}
                onClick={() =>
                  navigate(`/address/edit/${addr.id}`, {
                    state: {
                      returnTo,
                      product,
                      cartIds
                    }
                  })
                }
              >
                수정
              </span>    
              <span 
                style={styles.addressActionLink} 
                onClick={() => handleDelete(addr.id)}
              >
                삭제
              </span>
            </div>
          </div>

          <div style={{ marginBottom: '8px' }}>
            {returnTo ? (
              <span
                onClick={() => handleSelectAddress(addr)}
                style={styles.badgeSuccess}
              >
                이 배송지 선택
              </span>
            ) : (
              addr.is_default ? (
                <span style={styles.badgeSuccess}>
                  기본 배송지
                </span>
              ) : (
                <span
                  style={styles.badgeDefault}
                  onClick={() => handleSetDefault(addr.id)}
                >
                  기본 설정
                </span>
              )
            )}
          </div>

          <div className="address-content" style={styles.addressContent}>
            {addr.address}<br />
            {addr.detail_address}
          </div>
        </div>
      ))}
      
      {returnTo && (
        <div style={styles.btnRow}>
          <button
            type="button"
            style={styles.btnBasic}
            onClick={handleCancel}
          >
            돌아가기
          </button>
        </div>
      )}

    </div>
  );
};

// 원본 템플릿의 <style> 태그 내용을 그대로 React 스타일에 적용
const styles = {
  container: { maxWidth: '600px', margin: '20px auto 40px', fontFamily: 'sans-serif' },
  title: { marginBottom: '20px', fontWeight: 'bold' },
  addBtn: { 
    padding: '8px 16px', backgroundColor: '#0073e9', color: '#fff', 
    border: 'none', borderRadius: '4px', cursor: 'pointer', marginBottom: '20px' 
  },
  addressCard: { border: '1px solid #ddd', padding: '18px', marginBottom: '20px', borderRadius: '5px', background: '#ffffff' },
  addressHeader: { fontWeight: '700', marginBottom: '5px', display: 'flex', justifyContent: 'space-between' },
  addressDate: { color: '#999', fontSize: '0.85rem', fontWeight: 'normal' },
  addressContent: { whiteSpace: 'pre-wrap', lineHeight: '1.4', color: '#444', fontsize: '0.85rem' },
  addressActionLink: { fontSize: '0.85rem', color: '#6c757d', textDecoration: 'none', marginLeft: '10px', cursor: 'pointer' },
  badgeSuccess: { 
    padding: '4px 8px', fontSize: '0.75rem', borderRadius: '4px', 
    border: '1px solid #28a745', color: '#28a745', display: 'inline-block' 
  },
  badgeDefault: { 
    padding: '4px 8px', fontSize: '0.75rem', borderRadius: '4px', 
    border: '1px solid #ddd', color: '#333', cursor: 'pointer', display: 'inline-block' 
  },
  selectBtn: {
    width: '100%',
    padding: '10px',
    border: 'none',
    borderRadius: '4px',
    backgroundColor: '#0073e9',
    color: '#fff',
    cursor: 'pointer',
    fontWeight: '600'
  },
  btnRow: {
    display: 'flex',
    gap: '10px',
    justifyContent: 'flex-end',
    marginTop: '20px'
  },
  btnBasic: {
    padding: '12px 18px',
    borderRadius: '5px',
    border: '1px solid #ddd',
    background: '#fff',
    color: '#111',
    textDecoration: 'none',
    fontWeight: 600,
    cursor: 'pointer'
  },
};

export default AddressList;